import { useTopImpactStories } from '../../../shared/hooks/useTopImpactStories';
import type { TopStoryDesktop } from '../../../shared/types';

type Result = ModelHookResult<
	{
		desktopStories: TopStoryDesktop[];
	},
	{
		trackStoryClick: (url: string) => void;
	}
>;

const getPositionClasses = (index: number) => {
	switch (index) {
		case 1:
			return {
				top: 'top-[360px]',
				transform: 'translate-x-[-60%] translate-y-[-10%]',
			};
		case 2:
			return {
				top: 'top-[420px]',
			};
		case 3:
			return {
				top: 'top-[360px]',
				transform: 'translate-x-[60%] translate-y-[-10%]',
			};
		default:
			return {
				top: 'top-[20px]',
			};
	}
};

export function useTopImpactStoriesDesktop(): Result {
	const {
		data: { topStories },
		actions: { trackStoryClick },
	} = useTopImpactStories();

	return {
		data: {
			desktopStories: topStories.map((story, index) => ({
				...story,
				...getPositionClasses(index),
			})),
		},
		actions: {
			trackStoryClick,
		},
	};
}
